import AppConstants from 'constants/AppConstants';

import protos from 'utils/protos';

const { VisitPrimaryPatronUpdateRequest } = protos;

/**
 * Gets a purchase order. Despite tableside sunset, this is still used by SecondaryReceiptRoute.tsx , so it is still live code.
 */
export function getPurchaseOrder(visitEditToken: string): ApiAction {
  return {
    TockApi: {
      getProto: `/purchase/order/public/generate?token=${visitEditToken}`,
      type: AppConstants.NULL,
    },
  };
}

/**
 * Sets the primary patron for an order. Despite tableside sunset, this is still used by ContinueTableSideRoute.tsx,
 * which handles making outstanding payments on orders even if they are not tableside orders.
 * @param visitEditToken
 * @param patronId
 * @returns
 */
export function setOrderPrimaryPatron(visitEditToken: string, patronId?: number): ApiAction {
  return {
    TockApi: {
      putProto: `/visit/consumer/primary-patron`,
      request: VisitPrimaryPatronUpdateRequest.fromObject({ visitEditToken, patronId }),
      type: AppConstants.NULL,
    },
  };
}
